// footer.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationService } from '../../../core/services/navigation.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  public currentYear = new Date().getFullYear();
  public footerMenuItems = this.navigationService.getFooterSections();
  public socialLinks = this.navigationService.getSocialLinks().filter(link => link.icon === 'linkedin');
  public legalLinks = this.navigationService.getLegalLinks();
  public companyDescription = 'Industry Intelligence Inc. is the leading market intelligence platform. Our platform gives decision-makers the freedom to access real-time market data and competitive insights while allowing teams to easily analyze and distribute it anywhere.';

  constructor(private navigationService: NavigationService) {}
}